import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import {
  SettingsOutlined,
  ChevronLeft,
  ChevronRightOutlined,
  HomeOutlined,
  ShoppingCartOutlined,
  Groups2Outlined,
  ReceiptLongOutlined,
  PublicOutlined,
  PointOfSaleOutlined,
  TodayOutlined,
  CalendarMonthOutlined,
  AdminPanelSettingsOutlined,
  TrendingUpOutlined,
  PieChartOutlined,
  Spa,
  LanguageRounded,
  EditLocationRounded,
  Category,
  CategoryRounded,
  WebRounded,
  Redeem
} from "@mui/icons-material";

import { FlexBetween } from ".";
import profileImage from "assets/profile.jpeg";

// Nav items
const navItems = [
  // {
  //   text: "Dashboard",
  //   icon: <HomeOutlined />,
  // },
  // {
  //   text: "Client Facing",
  //   icon: null,
  // },
  // {
  //   text: "Products",
  //   icon: <ShoppingCartOutlined />,
  // },
  {
    // text: "Customers",
    text: "Users",
    icon: <Groups2Outlined />,
  },
  {
    // text: "Customers",
    text: "Reported Users",
    icon: <Groups2Outlined />,
  },
  {
    text: "EmoEase",
    icon: <Spa />,
  },
  {
    text: "Religion",
    icon: <EditLocationRounded />,
  },

  {
    text: "Language",
    icon: <LanguageRounded />,
  },
  {
    text: "Contact Us Categories",
    icon: <CategoryRounded />,
  },
  {
    text: "Create Request Categories",
    icon: <CategoryRounded />,
  },
  {
    text: "Service Provider Categories",
    icon: <CategoryRounded />,
  },
  {
    text: "User Interest Categories",
    icon: <CategoryRounded />,
  },

  {
    text: "User Activity Categories",
    icon: <CategoryRounded />,
  },
  {
    text: "Goal Categories",
    icon: <CategoryRounded />,
  },
  {
    text: "Website Interest",
    icon: <WebRounded />,
  },
  {
    text: "Yoga Empower Categories",
    icon: <CategoryRounded />,
  },
  {
    text: "Coupons",
    icon: <Redeem />,
  }
 
];

// Sidebar
const Sidebar = ({
  user,
  isNonMobile,
  drawerWidth,
  isSidebarOpen,
  setIsSidebarOpen,
}) => {
  // config
  const { pathname } = useLocation();
  const [active, setActive] = useState("");
  const navigate = useNavigate();
  const theme = useTheme();

  // set active path
  useEffect(() => {
    setActive(pathname.substring(1));
  }, [pathname]);

  return (
    <Box component="nav">
      {isSidebarOpen && (
        // Sidebar
        <Drawer
          open={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
          variant="persistent"
          anchor="left"
          sx={{
            width: drawerWidth,
            "& .MuiDrawer-paper": {
              color: theme.palette.secondary[200],
              backgroundColor: theme.palette.background.alt,
              boxSizing: "border-box",
              borderWidth: isNonMobile ? 0 : "2px",
              width: drawerWidth,
            },
            "& .MuiDrawer-paper::-webkit-scrollbar": {
              width: 0,
            },
          }}
        >
          <Box width="100%">
            {/* Brand Info */}
            <Box m="1.5rem 2rem 2rem 3rem">
              <FlexBetween color={theme.palette.secondary.main}>
                <Box display="flex" alignItems="center" gap="0.5rem">
                  <Typography
                    variant="h4"
                    fontWeight="bold"
                    onClick={() => {
                      navigate("/dashboard");
                      setActive("dashboard");
                    }}
                    sx={{
                      cursor: "pointer",
                    }}
                    title="Quellr"
                  >
                    Quellr
                  </Typography>
                </Box>
                {/* Mobile Sidebar Toggle Icon */}
                {!isNonMobile && (
                  <IconButton
                    onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                    title="Close Sidebar"
                  >
                    <ChevronLeft />
                  </IconButton>
                )}
              </FlexBetween>
            </Box>

            {/* Sidebar items */}
            <List>
              {navItems.map(({ text, icon }) => {
                if (!icon) {
                  return (
                    <Typography key={text} sx={{ m: "2.25rem 0 1rem 3rem" }}>
                      {text}
                    </Typography>
                  );
                }

                // lowercase text
                let lcText = text.toLowerCase();

                if (lcText === "contact us categories") {
                  lcText = "contactUsCategories"
                }
                if (lcText === "create request categories") {
                  lcText = "createRequestCategories"
                }
                if (lcText === "service provider categories") {
                  lcText = "serviceProviderCategories"
                }
                if (lcText === "user interest categories") {
                  lcText = "userInterestCategories"
                }
                if (lcText === "user activity categories") {
                  lcText = "userActivityCategories"
                }
                if (lcText === "goal categories") {
                  lcText = "goalCategories"
                }
                if (lcText === "reported users") {
                  lcText = "reportedUsers"
                }
                if(lcText === "website interest") {
                  lcText = "websiteInterest"
                } if(lcText === "yoga empower categories") {
                  lcText = "yogaEmpowerCategories"
                }if(lcText === "coupons") {
                  lcText = "coupons"
                }
       

                return (
                  <ListItem key={text} title={text} disablePadding>
                    <ListItemButton
                      onClick={() => {
                        setActive(text.toLowerCase());

                        navigate(`/${lcText}`);
                        console.log(lcText)

                      }}
                      sx={{
                        backgroundColor:
                          active === lcText
                            ? theme.palette.secondary[300]
                            : "transparent",
                        color:
                          active === lcText
                            ? theme.palette.primary[600]
                            : theme.palette.secondary[100],
                      }}
                    >
                      {/* icon */}
                      <ListItemIcon
                        sx={{
                          ml: "2rem",
                          color:
                            active === lcText
                              ? theme.palette.primary[600]
                              : theme.palette.secondary[200],
                        }}
                      >
                        {icon}
                      </ListItemIcon>

                      {/* text */}
                      <ListItemText
                        primary={text}
                        sx={{
                          fontSize: '18px', // size
                          fontWeight: 'bold', // font bold
                        }}
                      />
                      {active === lcText && (
                        <ChevronRightOutlined sx={{ ml: "auto" }} />
                      )}
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
          </Box>

       
        </Drawer>
      )}
    </Box>
  );
};

export default Sidebar;
